import { useDispatch } from 'react-redux';
import { updateWidgetAttribute } from '../redux/dashboardSlice';

export const useSetWidgetAttribute = (id) => {
  const dispatch = useDispatch();

  return (path, value) => {
    dispatch(updateWidgetAttribute({ id, path, value }));
  };
}
